<main class="main-shell min-h-screen px-4 py-6 text-slate-900 sm:px-6 lg:px-8">
  <section class="mx-auto flex w-full max-w-7xl flex-col gap-6">
    <header class="topbar flex flex-col gap-5 p-5 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-center gap-4">
        <div class="brand-mark">
          <span>{{ 'common.brand' | translate }}</span>
        </div>

        <div>
          <p class="mb-1 text-xs font-semibold uppercase tracking-[0.22em] text-cyan-700">{{ 'common.ssoBrand' | translate }}</p>
          <h1 class="m-0 text-2xl font-semibold tracking-normal text-slate-950">{{ 'main.title' | translate }}</h1>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <a nz-button routerLink="/account/privacy-policy">
          <nz-icon nzType="file-protect"></nz-icon>
          <span class="ml-2">{{ 'main.privacyPolicy' | translate }}</span>
        </a>

        <button
          nz-button
          nz-dropdown
          type="button"
          nzTrigger="click"
          [nzDropdownMenu]="mainMenu"
          nzPlacement="bottomRight"
          [attr.aria-label]="'main.menu' | translate"
        >
          <nz-icon nzType="menu"></nz-icon>
        </button>

        <nz-dropdown-menu #mainMenu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item routerLink="/auth-logs">
              <nz-icon nzType="clock-circle"></nz-icon>
              <span class="ml-2">{{ 'main.myLogins' | translate }}</span>
            </li>
            @if (isSuperAdmin()) {
              <li nz-menu-item routerLink="/admin/auth-logs">
                <nz-icon nzType="file-search"></nz-icon>
                <span class="ml-2">{{ 'main.adminLogins' | translate }}</span>
              </li>
            }
            @if (isAdmin()) {
              <li nz-menu-item routerLink="/admin/users">
                <nz-icon nzType="team"></nz-icon>
                <span class="ml-2">{{ 'main.manageUsers' | translate }}</span>
              </li>
            }
            @if (isSuperAdmin()) {
              <li nz-menu-item routerLink="/admin/security-policy">
                <nz-icon nzType="safety-certificate"></nz-icon>
                <span class="ml-2">{{ 'main.securityPolicy' | translate }}</span>
              </li>
            }
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="logout()">
              <nz-icon nzType="logout"></nz-icon>
              <span class="ml-2">{{ 'main.logout' | translate }}</span>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </header>

    @if (errorMessage) {
      <nz-alert
        nzType="error"
        [nzMessage]="errorMessage"
        nzShowIcon
      ></nz-alert>
    }

    <ng-template #moduleCard let-card>
      <button
        class="module-card"
        [class.module-card-selected]="selectedKey === card.key"
        type="button"
        [disabled]="isRedirecting"
        (click)="selectCard(card)"
      >
        <span class="module-card-accent"></span>

        <span class="module-card-icon">
          <img [src]="card.imageUrl" [alt]="card.titleKey | translate">
        </span>

        <span class="module-card-content">
          <span class="module-card-title">{{ card.titleKey | translate }}</span>
          <span class="module-card-subtitle">{{ card.subtitleKey | translate }}</span>
        </span>

        @if (selectedKey === card.key) {
          @if (isRedirecting) {
            <nz-spin nzSimple nzSize="small"></nz-spin>
          } @else {
            <nz-tag nzColor="cyan">{{ 'main.go' | translate }}</nz-tag>
          }
        }
      </button>
    </ng-template>

    <nz-spin [nzSpinning]="isLoadingSystems">
      @if (!isLoadingSystems && (primaryCard || moduleCards.length)) {
        <section class="grid gap-6">
          @if (primaryCard) {
            <ng-container *ngTemplateOutlet="moduleCard; context: { $implicit: primaryCard }"></ng-container>
          }

          @if (moduleCards.length) {
            <div class="flex flex-col gap-4">
              <div class="section-heading">
                <p>{{ 'main.modules.heading' | translate }}</p>
                <span>{{ 'main.choosePrompt' | translate }}</span>
              </div>

              <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                @for (card of moduleCards; track card.key) {
                  <ng-container *ngTemplateOutlet="moduleCard; context: { $implicit: card }"></ng-container>
                }
              </div>
            </div>
          }
        </section>
      }

      @if (!isLoadingSystems && !primaryCard && !moduleCards.length) {
        <div class="empty-panel">
          <nz-empty [nzNotFoundContent]="'main.empty' | translate"></nz-empty>
        </div>
      }
    </nz-spin>
  </section>
</main>
